import { graphql } from '../../../gql';

export const PUBLISH_CONSTRAINTS_QUERY = graphql(`
  query publishConstraints {
    publishConstraints {
      minStoryLength
      minReplyLength
    }
  }
`);
